import { type FC } from 'react';

import { Button } from 'dibs-elements/exports/Button.tsx';

import styles from './OktaLoginButton.scss';

const OktaLoginButton: FC<{ onClick?: () => void; href?: string }> = ({ onClick, href }) => {
    return (
        <div className={styles.buttonWrapper}>
            <Button
                onClick={onClick}
                href={href}
                type="primaryAlt"
                fullWidth
                className={styles.button}
            >
                LOG IN WITH OKTA
            </Button>
        </div>
    );
};

export default OktaLoginButton;
